import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table } from "semantic-ui-react";

export const DivTimer = styled.div`
height: 10rem;
width: 30rem;
font-family: 'Share Tech Mono', monospace;
  color: #ffffff;
  text-align: center;
  color: #daf6ff;
  background-color:#767676;
  padding: 1rem;
  border-radius: 10px;
`;

export const Timer = styled.p`
letter-spacing: 0.05em;
      font-size: 80px;
      padding: 5px 0;
`;